<form [formGroup]="locationForm">
    <mat-form-field class="col-12">
        <mat-label>Select {{ facility.toUpperCase() }} station</mat-label>
        <mat-select
            formControlName="location"
            name="location"
            id="location"
            (selectionChange)="onSelectShipmentLocation()"
        >
            @for (destination of supportedDestinations; let destinationIndex = $index; track destinationIndex) {
                <mat-option [value]="destination"> {{ destination }} </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <ng-template [ngTemplateOutlet]="buttonTemplateRef" [ngTemplateOutletContext]="{ $implicit: locationForm }" />
</form>
